import { useResize } from 'shared/lib/hooks/useResize/useResize';
import { backgroundsData } from 'shared/lib/backgroundsData/backgroundsData';

interface IUseBackground {
    background: string
    tnBackground: string
}

export const useBackgrounds = (value: string): IUseBackground => {
    const windowWidth = useResize();

    const getSize = () => {
        if (windowWidth <= 1200 && windowWidth >= 1024) return 1200;
        if (windowWidth <= 1024 && windowWidth >= 768) return 1024;
        if (windowWidth <= 768 && windowWidth >= 480) return 768;
        if (windowWidth <= 480) return 370;

        return 1700;
    };

    // if (typeof value === 'string') {
    return {
        background: backgroundsData[value][getSize()],
        tnBackground: backgroundsData[value].tn,
    };
    // }

    // const data: any = {};
    //
    // value.map((name) => (
    //     data[name] = {
    //         background: backgroundsData[name][getSize()],
    //         tnBackground: backgroundsData[name].tn,
    //     }
    // ));
};
